import BREAKPOINTS from '@mlb/react-patterns/v4/style/breakpoints';

const mobileBreakpointNum = parseInt(BREAKPOINTS.lg, 10) - 1;
const mobileBreakpoint = `${mobileBreakpointNum}px`;

const breakpoints = {
    mobile: mobileBreakpoint,
    medium: BREAKPOINTS.xl
};

export default breakpoints;
